export default {
  "site.name": "精品久久久",
  "site.slogan": "高品质精选内容长效平台",
  "site.description": "汇聚经久不衰的优质内容与精品资源，为您提供持久、稳定、高价值的极致体验",
  "nav.home": "首页",
  "nav.categories": "分类浏览",
  "nav.about": "关于我们",
  "nav.search": "搜索",
  "footer.copyright": "版权所有",
  "home.hero.title": "精品久久久",
  "home.hero.subtitle": "高品质精选内容长效平台",
  "home.featured": "精选推荐",
  "home.categories": "内容分类",
  "home.popular": "热门文章",
  "home.newsletter": "订阅精选",
  "home.viewAll": "查看全部",
  "home.startExplore": "开始探索",
  "home.learnMore": "了解更多",
  "category.articles": "篇文章",
  "category.noArticles": "该分类暂无文章",
  "article.notFound": "文章未找到",
  "article.relatedArticles": "相关推荐",
  "article.share": "分享至：",
  "about.title": "关于我们",
  "about.brandStory": "品牌故事",
  "about.values": "核心价值",
  "about.testimonials": "用户口碑",
  "about.faq": "常见问题",
  "about.contact": "联系我们",
  "about.sendMessage": "发送消息",
  "newsletter.subscribe": "立即订阅",
  "newsletter.placeholder": "输入您的邮箱地址",
};